'use strict';

angular
  .module('systemOwnerReviewControllers.ConfirmSystemOwnership')

  .controller('ConfirmSystemOwnershipController', [
    '$scope',
    '$state',
    '$translate',
    'topBar',
    'systemsToReview',
    function ($scope, $state, $translate, topBar, systemsToReview) {
      // When no selected system type, then go to the first one
      if ($state.is('systemOwnerReview.authUser.confirmSystemOwnership')) {
        if (systemsToReview.length > 0) {
          var firstSystem = systemsToReview[0];
          $state.go('systemOwnerReview.authUser.confirmSystemOwnership.bySystemType', {
            systemTypeSlug: firstSystem.SystemTypeSlug,
            authLogin: $scope.authLogin,
          });
        }
      }

      // Misc
      $translate('iam.admin.systemOwnerReview.confirmSystemOwnership.pageTitle').then(function (translation) {
        topBar.setTitleAndIcon(translation, 'fa-key');
      });

      $scope.systemsToReview = systemsToReview;

      // Review a system type
      $scope.goToReviewSystemType = function (systemType) {
        $state.go('systemOwnerReview.authUser.confirmSystemOwnership.bySystemType', {
          systemTypeSlug: systemType.Slug,
          authLogin: $scope.authLogin,
        });
      };

      // Current state, is for this system type ?
      $scope.isReviewForSystemType = function (systemType) {
        // Network Share ?
        //if (systemType.SystemTypeID === 4) {
        //    return $state.includes('userAccessRequest.edit.networkShare');
        //}
        //else {
        return (
          $state.includes('systemOwnerReview.authUser.confirmSystemOwnership.bySystemType') &&
          $state.params.systemTypeSlug === systemType.Slug
        );
        //}
      };
    },
  ]);
